import { useHeaderTitle } from '@blend-ed/blendx-platform';
import React, { useEffect, useMemo, useState } from 'react';
import ProgramCard from '../../../components/ProgramCard';
import { useDiscoverPrograms } from '../../../hooks/programs/useFetchPrograms';

import { EmptyState, Pagination, Search } from '@blend-ed/blendx-ui';


function ProgramsDiscover() {
    const { setTitle } = useHeaderTitle()
    const [searchValue, setSearchValue] = useState('')

    const { discoverPrograms, loading } = useDiscoverPrograms()

    const allProgramData = discoverPrograms || []

    const filteredProgramData = useMemo(() => {
        return allProgramData.filter(program => program.name.toLowerCase().includes(searchValue.toLowerCase()))
    }, [allProgramData, searchValue])

    const [cardsPerPage, setCardsPerPage] = useState(8);
    const [pageNumber, setPageNumber] = useState(0);

    const pagesVisited = pageNumber * cardsPerPage;
    const paginatedProgramData = filteredProgramData.slice(pagesVisited, pagesVisited + cardsPerPage);
    const totalPages = Math.ceil(filteredProgramData.length / cardsPerPage);

    const gotoPage = (page) => {
        setPageNumber(page);
    };

    const nextPage = () => {
        setPageNumber(old => Math.min(old + 1, totalPages - 1));
    };

    const previousPage = () => {
        setPageNumber(old => Math.max(old - 1, 0));
    };

    const canNextPage = pageNumber < totalPages - 1;
    const canPreviousPage = pageNumber > 0;

    useEffect(() => {
        setTitle('Discover / Programs')
    }, [])

    return (
        <main>
            <div className='discover-programs'>
                <div className='discover-programs-header'>
                    <Search onChange={(e) => { setSearchValue(e) }} />
                </div>
                {filteredProgramData.length > 0 ? (
                    <>
                        <div className="discover-programs-content">
                            {paginatedProgramData.map((program, index) => (
                                <ProgramCard
                                    key={index}
                                    title={program.name}
                                    description={program.description}
                                    estimatedTime={program.duration}
                                    durationMetric={program.durationMetric}
                                    link={`/program/${program.id}`}
                                    image={program.image}
                                    price={program.price}
                                    courseCount={program.programCoursesAggregate.agg_count}
                                    discover={true}
                                />
                            ))}
                        </div>
                        <div className="discover-programs-pagination-footer">
                            {
                                filteredProgramData.length > cardsPerPage && (
                                    <Pagination
                                        previousPage={previousPage}
                                        totalPages={totalPages}
                                        currentPage={pageNumber}
                                        gotoPage={gotoPage}
                                        nextPage={nextPage}
                                        canPreviousPage={canPreviousPage}
                                        canNextPage={canNextPage}
                                        itemsPerPage={cardsPerPage}
                                        changeItemsPerPage={setCardsPerPage}
                                    />
                                )
                            }
                        </div>
                    </>
                ) : (
                    <div className="discover-programs-empty">
                        <EmptyState type="box" className="mx-auto" message="No Programs Found" />
                    </div>
                )}
            </div>
        </main>
    )
}

export default ProgramsDiscover